import React from 'react';
import CountUp from 'react-countup';
import TrackVisibility from "react-on-screen";

const Data = [
    {
        countNum : 4000,
        countTitle: 'Counseled People.',
    },
    {
        countNum : 15,
        countTitle: 'Years of Experience',
    },
    {
        countNum : 200,
        countTitle: 'Individual Clients',
    },
    {
        countNum : 35,
        countTitle: 'Company',
    },
    {
        countNum : 12,
        countTitle: 'Usefull Programmes',
    },
    {
        countNum : 60000000,
        countTitle: 'Debt Recoverd',
    },
    {
        countNum : 320000000,
        countTitle: 'Value Generated',
    },
];
const CounterUpFour = ({textALign, counterStyle, column}) => {
    return (
        <div className="row">
            {Data.map((data, index) => (
                <div className={`w-auto mx-auto ${column}`} key={index}>
                    <div className={`count-box ${counterStyle} ${textALign}`}>
                        <TrackVisibility once>
                            {({ isVisible }) => isVisible && 
                                <div className="count-number">{isVisible ? <CountUp end={data.countNum} /> : 0}</div>}
                        </TrackVisibility>
                        <h5 className="counter-title">{data.countTitle}</h5>
                    </div>
                </div>
            ))}
        </div>
    )
}
export default CounterUpFour;